
export default function WorkTemplateRemarksView() {

    let workType="";
    let startTime="";
    let endTime="";
    let breakHour="";
    let breakMin="";
    let remarks="";
    let showBreak=true;
    return {
        view: (vnode) => {
            let data=vnode.attrs.data;
            startTime=data.startTime;
            workType=data.workType;
            endTime=data.endTime;
            if(data.breakHour){
             let arr=data.breakHour.split(':');
             breakHour=Number(arr[0])+" hr";
             breakMin=Number(arr[1])==0?"": Number(arr[1])+" min";
             if((Number(arr[0])+Number(arr[1]))>0){
                showBreak=true;
             }else{
                showBreak=false;
             }
            }
            remarks=data.remarks;
            return [
                vnode.attrs.data.workType=="001" && m('.d-grid.gap-2.d-sm-flex',m('span',startTime+" ~ "),m('span',endTime),
                showBreak && m('span',m('i.bi.bi-cup-fill')),
                showBreak && m('span',breakHour),
                showBreak && m('span',breakMin)
                ),

                vnode.attrs.data.workType !="001" && m('.d-grid.gap-2.d-sm-flex',m('span',vnode.attrs.data.remarks))
            
            ]
        }
    }
}
